// extracted by mini-css-extract-plugin
export default {"logoutIcon":"UserMenu_logoutIcon__gp+DY","userMenu":"UserMenu_userMenu__tYyoU","accountLink":"UserMenu_accountLink__xbzd-"};